import curry from 'lodash/fp/curry'
import {
  createRoutine as create,
  bindPromiseCreators as routinesBindPromises
} from 'redux-saga-routines'

/**
 * @typedef {Object} routine - actions for routine
 * @property {String} TRIGGER - action type for trigger routine action
 * @property {String} REQUEST - action type for request routine action
 * @property {String} SUCCESS - action type for success routine action
 * @property {String} FAILURE - action type for failure routine action
 * @property {String} FULFILL - action type for fulfill routine action
 * @property {function} trigger - action creator for trigger routine action
 * @property {function} request - action creator for request routine action
 * @property {function} success - action creator for success routine action
 * @property {function} failure - action creator for failure routine action
 * @property {function} fulfill - action creator for fulfill routine action
 */

/** @const {String} APP_TYPE_PREFIX - default module prefix for routines */
export const APP_TYPE_PREFIX = 'triodos-onboarding'

/**
 * creates routine with module prefix
 *
 * @param {String} typePrefix - action type prefix
 * @param {function} payloadCreator - payload creator
 * @param {function} metaCreator - meta creator
 * @param {String} [modulePrefix=APP_TYPE_PREFIX] - action type module prefix
 * @return {routine} created routine
 */
export const createRoutine = (
  typePrefix,
  payloadCreator,
  metaCreator,
  modulePrefix = APP_TYPE_PREFIX
) => create(`${modulePrefix}/${typePrefix}`, payloadCreator, metaCreator)

/**
 * curried version of redux-saga-routines bindPromiseCreator
 *
 * @sig (Object|Fn -> Fn) -> Object
 * @param {Object|Function} promiseCreators - redux saga routines promiseCreators
 * @param {Function} dispatch - redux dispatch
 * @return {Object} props bound promises
 */
export const bindPromiseCreators = curry(routinesBindPromises)
